export const SELECT_CATEGORY = 'SELECT_CATEGORY'